import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1)
const _hoisted_3 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_4 = { class: "py-4 px-5 md:px-6 border-b mb-6 flex items-center justify-between" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex items-center" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg md:text-2xl font-medium text-gray-900" }, " Create new deal ")
], -1)
const _hoisted_6 = { class: "mb-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "type"
}, " Hubspot deal ID (optional) ", -1)
const _hoisted_8 = { class: "mb-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "type"
}, " Is this a business loan or an investment property loan? ", -1)
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Investment Property", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, "Business", -1)
const _hoisted_13 = { class: "mb-6 w-80" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "loan-amount"
}, " Loan Amount ", -1)
const _hoisted_15 = { class: "w-full relative" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 sm:text-sm" }, "$")
], -1)
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "flex items-center flex-wrap" }
const _hoisted_19 = ["name", "value", "onUpdate:modelValue"]
const _hoisted_20 = { class: "text-sm" }
const _hoisted_21 = { class: "flex flex-wrap" }
const _hoisted_22 = { class: "mb-4 w-full md:w-1/2 pr-4" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "firstName"
}, " First Name ", -1)
const _hoisted_24 = { class: "mb-4 w-full md:w-1/2 pr-4" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "lastName"
}, " Last Name ", -1)
const _hoisted_26 = { class: "w-full md:w-1/2 pr-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "email"
}, " Email ", -1)
const _hoisted_28 = { class: "w-full md:w-1/2 pr-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "phoneNumber"
}, " Phone Number ", -1)
const _hoisted_30 = { class: "mt-6 flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "fixed z-10 inset-0 overflow-y-auto",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.closeModal('ModalNewDeal')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalNewDeal')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _createElementVNode("form", {
            class: "px-5 md:px-6 pb-6",
            onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
          }, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                placeholder: "5805208761",
                name: "hubspotID",
                class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm py-2 px-3 text-gray-700",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.hubspotID) = $event))
              }, null, 512), [
                [_vModelText, _ctx.collectedData.hubspotID]
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", {
                  class: _normalizeClass(["py-2 px-5 border rounded-md mr-2 cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.collectedData.type == 'Investment Property' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "hidden",
                    name: "type",
                    value: "Investment Property",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.type) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.collectedData.type]
                  ]),
                  _hoisted_11
                ], 2),
                _createElementVNode("label", {
                  class: _normalizeClass(["py-2 px-5 border rounded-md mr-2 cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.collectedData.type == 'Business' }])
                }, [
                  _withDirectives(_createElementVNode("input", {
                    type: "radio",
                    class: "hidden",
                    name: "type",
                    value: "Business",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.collectedData.type) = $event))
                  }, null, 512), [
                    [_vModelRadio, _ctx.collectedData.type]
                  ]),
                  _hoisted_12
                ], 2)
              ])
            ]),
            (!!_ctx.collectedData.type)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("input", {
                        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 pl-6 text-gray-700",
                        id: "loan-amount",
                        type: "text",
                        placeholder: "1,000,000",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.collectedData.loanAmount) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.loanAmount]
                      ])
                    ])
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.config[_ctx.collectedData.type], ({ key, label, options}) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "mb-4",
                      key: key
                    }, [
                      _createElementVNode("label", {
                        class: "block text-gray-700 text-sm font-bold mb-2",
                        for: key
                      }, _toDisplayString(label), 9, _hoisted_17),
                      _createElementVNode("div", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options, (item, index) => {
                          return (_openBlock(), _createElementBlock("label", {
                            class: _normalizeClass(["py-2 px-5 border rounded-md mr-2 mb-2 cursor-pointer", { 'bg-gray-200 border-gray-200': _ctx.collectedData[key] == item }]),
                            key: index
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "radio",
                              class: "form-radio cursor-pointer hidden",
                              name: key,
                              value: item,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.collectedData[key]) = $event)
                            }, null, 8, _hoisted_19), [
                              [_vModelRadio, _ctx.collectedData[key]]
                            ]),
                            _createElementVNode("span", _hoisted_20, _toDisplayString(item), 1)
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  }), 128)),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _hoisted_23,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "firstName",
                        placeholder: "John",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.collectedData.firstName) = $event)),
                        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700"
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.firstName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "lastName",
                        placeholder: "Doe",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.collectedData.lastName) = $event)),
                        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700"
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.lastName]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "email",
                        placeholder: "person@example.com",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.collectedData.email) = $event)),
                        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700"
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.email]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "phoneNumber",
                        placeholder: "(123) 456-7890",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.collectedData.phone) = $event)),
                        class: "appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3 text-gray-700"
                      }, null, 512), [
                        [_vModelText, _ctx.collectedData.phone],
                        [_directive_maska, '(###) ###-####']
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("button", {
                type: "submit",
                class: _normalizeClass(["bg-sky text-white rounded-md text-sm px-3 py-2", { 'opacity-50 cursor-pointer pointer-events-none': !_ctx.isValid || _ctx.loading }])
              }, " Continue ", 2)
            ])
          ], 32)
        ])
      ])
    ])
  ]))
}